<script setup lang="ts">
import type { ButtonSize } from '@global-types/buttonSize.ts';
import type { ButtonVariant } from '@global-types/buttonVariant.ts';
import type { ButtonType } from '@global-types/buttonType.ts';
import { computed } from 'vue';

const props = withDefaults(defineProps<{
  variant?: ButtonVariant,
  size?: ButtonSize,
  type?: ButtonType,
}>(), {
  type: 'button',
});

const classes = computed<string[]>(() => {
  const classList = [];
  if (props.variant) {
    classList.push(`btn--${props.variant}`);
  }

  if (props.size) {
    classList.push(`btn--${props.size}`);
  }

  return classList;
});
</script>

<template>
  <button
    class="btn"
    :class="classes"
    :type="type"
  >
    <slot />
  </button>
</template>
